import { render, staticRenderFns } from "./Item17Contact.vue?vue&type=template&id=4ff7bf9e&"
import script from "./Item17Contact.vue?vue&type=script&lang=js&"
export * from "./Item17Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports